<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Rapture's Slave</h1>
</div>
</div>
<h3>
	​Becky Lee Weyrich</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_xxxxxxxxxxxxx_Title.vue?16d18e01